/**
 * Shared constants for rest-api and its test mock.
 * Reduces duplication between src/services/api/rest-api.ts and __mocks__.
 */

export const IGNORED_ENDPOINTS_ON_401 = [
  '/login/code',
  '/tenant/login/code',
  '/tenant/login',
  '/tenant/login/resend-code',
  '/tenant/login/google',
  '/login/reference-key',
  '/login',
  '/reset-password',
  '/send-reset-password-email',
  '/logout',
  '/login-rfi-recipient',
];
